import { loadStripe } from '@stripe/stripe-js'

declare const process: {
  env: {
    REACT_APP_STRIPE_PUBLIC_KEY: string
    REACT_APP_STRIPE_LIVE_PUBLIC_KEY: string
    NODE_ENV: string
  }
}

const stripePublicKey =
  process.env.NODE_ENV === 'production'
    ? 'pk_live_51KponfFON0KAu5b3qJeBZEnZpmTmctJ4ZNaA2YObRBLYG6KuBr5bZ88yGW2sE0XZIdJ8J8gSJJDaXnK0oCZJrq8j00GlqBa9D8' // replace with orbit production key. currently using Orbit Payments key
    : process.env.NODE_ENV === 'staging'
    ? 'pk_live_51KponfFON0KAu5b3qJeBZEnZpmTmctJ4ZNaA2YObRBLYG6KuBr5bZ88yGW2sE0XZIdJ8J8gSJJDaXnK0oCZJrq8j00GlqBa9D8' // Orbit Payments key
    : 'pk_test_51KponfFON0KAu5b3AttXGYC1w7qCw9PoWeuui7ZWbo9gRBt3bWBppZC0oYVbYhCYchw4K7NKA5IK9YcsCZ9U6SD400ZPyAkFW1' // Orbit Payments test key

const initStripe = () => loadStripe(stripePublicKey)

export default initStripe
